exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cog-button[data-v-4c99e466] {\n}\n.text-popover[data-v-4c99e466] {\n  width: 320px;\n  position: absolute;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, .25);\n  box-shadow: 0 3px 10px rgba(0, 0, 0, .25);\n  z-index: 9999;\n  background-color: #fff;\n  padding: 1rem;\n}\n", ""]);

// exports
